import { cn } from "@/components/podkit/lib/cn";

function FreeCreditsPromotionBanner({ className }: { className?: string }) {
    return (
        <div
            className={cn("rounded-lg bg-white/70 px-4 py-2.5 backdrop-blur-sm dark:bg-white/10", className)}
            role="status"
        >
            <p className="text-center text-base text-content-primary">
                Upgrade to Core to get <span className="font-medium text-content-primary">$100 in free credits</span>{" "}
                and access to{" "}
                <a
                    href="https://ona.com/docs/ona/automations/overview"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-medium text-content-primary underline decoration-content-primary/30 hover:decoration-content-primary"
                >
                    Automations
                </a>
            </p>
        </div>
    );
}

export default FreeCreditsPromotionBanner;
